import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function CruisePurchaseCruiseTable() {
  const { t } = useTranslation();
  const name = 'approvalable.cruisePurchases.0';
  const value = HOCWatchValue({ keys: [name] });
  const columns = [
    {
      header: t('common:cruise_line'),
      accessorKey: 'cruiseName',
      minSize: 180,
      maxSize: 200,
      dataType: ColumnDataType.text,
    },
    {
      header: t('cruise:ship'),
      accessorKey: 'cruiseShipName',
      minSize: 180,
      maxSize: 200,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:from'),
      accessorKey: 'startedAt',
      minSize: 150,
      maxSize: 150,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:to'),
      accessorKey: 'endedAt',
      minSize: 150,
      maxSize: 150,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:departure'),
      accessorKey: 'startedAt',
      minSize: 100,
      maxSize: 150,
      dataType: ColumnDataType.time,
    },
    {
      header: t('common:arrival'),
      accessorKey: 'endedAt',
      minSize: 100,
      maxSize: 150,
      dataType: ColumnDataType.time,
    },
    {
      header: t('common:route'),
      accessorKey: 'route',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={[value[name]]}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
